/* tslint:disable */
/* eslint-disable */
/**
 * Property Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.0.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    NewsletterLocation,
    NewsletterLocationFromJSON,
    NewsletterLocationFromJSONTyped,
    NewsletterLocationToJSON,
} from './';

/**
 * 
 * @export
 * @interface NewsletterSchemaIn
 */
export interface NewsletterSchemaIn {
    /**
     * 
     * @type {string}
     * @memberof NewsletterSchemaIn
     */
    name: string;
    /**
     * 
     * @type {Array<NewsletterLocation>}
     * @memberof NewsletterSchemaIn
     */
    locations: Array<NewsletterLocation>;
    /**
     * 
     * @type {string}
     * @memberof NewsletterSchemaIn
     */
    module?: string;
}

export function NewsletterSchemaInFromJSON(json: any): NewsletterSchemaIn {
    return NewsletterSchemaInFromJSONTyped(json, false);
}

export function NewsletterSchemaInFromJSONTyped(json: any, ignoreDiscriminator: boolean): NewsletterSchemaIn {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'locations': ((json['locations'] as Array<any>).map(NewsletterLocationFromJSON)),
        'module': !exists(json, 'module') ? undefined : json['module'],
    };
}

export function NewsletterSchemaInToJSON(value?: NewsletterSchemaIn | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'locations': ((value.locations as Array<any>).map(NewsletterLocationToJSON)),
        'module': value.module,
    };
}


